jQuery(function ($) {
    const $body = $('body');
    let hasError = false;

    const t = theme.translate;

    const API = (function () {
        const BASE_URL = theme.settings.apiServerUrl;
        const useStorage = Boolean(theme.settings.wishlistUseLocalStorage);

        const getWishlists = () => {
            if (useStorage) {
                return LocalStorage.getWishlists();
            }

            return new Promise(function (resolve, reject) {
                getRequest('/wishlists')
                    .then(resp => resolve(resp.lists || []))
                    .catch(err => reject(err.message));
            });
        };

        const getWishlist = (id) => {
            if (useStorage) {
                return LocalStorage.getWishlist(id);
            }

            return new Promise((resolve, reject) => {
                getRequest(`/wishlists/${id}`)
                    .then((resp) => resolve(resp))
                    .catch(err => reject(err.message));
            });
        };

        const createWishlist = (title) => {
            if (useStorage) {
                return LocalStorage.createWishlist(title);
            }

            return new Promise(function (resolve, reject) {
                postRequest('/wishlists', { title })
                    .then(resp => resolve(resp._id))
                    .catch(err => reject(err.message));
            });
        };

        const clearWishlist = (id) => {
            if (useStorage) {
                return LocalStorage.clearWishlist(id);
            }

            return postRequest(`/wishlists/${id}/clear_items`);
        };

        const deleteWishlist = (id) => {
            if (useStorage) {
                return LocalStorage.deleteWishlist(id);
            }

            return deleteRequest(`/wishlists/${id}`);
        };

        const addItemToList = (listId, itemId) => {
            if (useStorage) {
                return LocalStorage.addItemToList(listId, itemId);
            }

            return postRequest(`/wishlists/${listId}/add_item`, { productID: String(itemId) });
        };

        const removeItemFromList = (listId, itemId) => {
            if (useStorage) {
                return LocalStorage.removeItemFromList(listId, itemId);
            }

            return postRequest(`/wishlists/${listId}/delete_item`, { productID: String(itemId) });
        };

        const _getConfig = (path, data = {}, config = {}) => {
            return {
                url: `${BASE_URL}${path}`,
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                async: true,
                headers: {
                    'x-customer-access-token': theme.storage.get('customer_access_token'),
                },
                ...config
            };
        };

        const getRequest = (path, data = {}, config = {}) => {
            return $.ajax({
                method: 'GET',
                ...(_getConfig(path, data, config)),
            });
        };

        const postRequest = (path, data = {}, config = {}) => {
            return $.ajax({
                method: 'POST',
                ...(_getConfig(path, data, config)),
            });
        };

        const putRequest = (path, data = {}, config = {}) => {
            return $.ajax({
                type: 'PUT',
                ...(_getConfig(path, data, config)),
            });
        };

        const deleteRequest = (path, data = {}, config = {}) => {
            return $.ajax({
                type: 'DELETE',
                ...(_getConfig(path, data, config)),
            });
        };

        return {
            getWishlists,
            getWishlist,
            createWishlist,
            clearWishlist,
            putRequest,
            deleteWishlist,
            addItemToList,
            removeItemFromList,
        };
    })();

    const LocalStorage = (function () {
        const KEY = 'wb_wishlists';

        const get = (key) => {
            return localStorage.getItem(key);
        }

        const getWishlistsFromStorage = () => {
            try {
                let list = JSON.parse(get(KEY));
                list = Array.isArray(list) ? list : [];
                list = list.map(i => {
                    i.items = i.items || [];
                    return i;
                });
                return list;
            } catch (e) {
                return [];
            }
        }

        const set = (key, value) => {
            localStorage.setItem(key, value);
        }

        const setWishlists = (wishlists) => {
            set(KEY, JSON.stringify(wishlists));
        }

        const getWishlists = () => {
            return Promise.resolve(getWishlistsFromStorage());
        };

        const getWishlist = (id) => {
            let wishlist = getWishlistsFromStorage().find(w => w._id == id);

            return new Promise((resolve) => {
                theme.StorefrontApi.getProducts(wishlist.items, { featuredImageArgs: { maxWidth: 150 } })
                    .then(products => {
                        wishlist.products = products.map(p => {
                            return {
                                ...p,
                                slug: p.handle,
                            }
                        });

                        resolve(wishlist);
                    })
            });
        };

        const createWishlist = (title) => {
            let wishlists = getWishlistsFromStorage();
            id = uid();

            wishlists.push({
                _id: id,
                title,
                items: [],
            });

            setWishlists(wishlists);

            return Promise.resolve(id);
        };

        const clearWishlist = async (id) => {
            let wishlists = getWishlistsFromStorage().map(w => {
                if (w._id == id) {
                    w.items = [];
                }
                return w;
            });

            setWishlists(wishlists);

            return Promise.resolve(true);
        };

        const deleteWishlist = async (id) => {
            let wishlists = getWishlistsFromStorage().filter(w => w._id !== id);

            setWishlists(wishlists);

            return Promise.resolve(true);
        };

        const addItemToList = (listId, itemId) => {
            return new Promise((resolve) => {
                theme.StorefrontApi.getProduct(itemId)
                    .then(product => {
                        if (product) {
                            let wishlists = getWishlistsFromStorage().map(w => {
                                if (w._id == listId) {
                                    w.type = product.stockType;
                                    w.items.push(String(itemId));
                                }
                                return w;
                            });

                            setWishlists(wishlists);
                        }

                        resolve(true);
                    });
            });
        };

        const removeItemFromList = (listId, itemId) => {
            let wishlists = getWishlistsFromStorage().map(w => {
                if (w._id == listId) {
                    w.items.splice(w.items.indexOf(String(itemId)), 1);
                }

                return w;
            });

            setWishlists(wishlists);

            return Promise.resolve(true);
        };

        const uid = () => {
            return Date.now().toString(36) + Math.random().toString(36).substr(2);
        }

        return {
            getWishlists,
            getWishlist,
            createWishlist,
            clearWishlist,
            deleteWishlist,
            addItemToList,
            removeItemFromList,
        }
    })();

    const Wishlists = (function () {
        let currentWishlists = [],
            lastAddedProductId = null;

        const getAll = () => {
            return currentWishlists;
        };

        const getById = (id) => {
            for (let w of currentWishlists) {
                if (w._id = id) {
                    return w;
                }
            }
            return null;
        };

        const getDetails = (id) => {
            return new Promise((resolve) => {
                API.getWishlist(id)
                    .then((data) => {
                        const items = data.products.map(p => {
                            if (!p) {
                                return null;
                            }

                            return {
                                ...p,
                                id: p.id.slice(p.id.lastIndexOf('/') + 1), // get last part from gid://shopify/Product/xxxxxxxxxxxxx
                                url: Shopify.routes.root + `products/${p.slug}`,
                            };
                        });

                        resolve({
                            id,
                            title: data.title,
                            items,
                        });
                    });
            });
        };

        const getAllWithProduct = (productId) => {
            return currentWishlists.filter(w => w.items.includes(String(productId)));
        };

        const hasProduct = (productId, wishlistId = null) => {
            let wishlists = wishlistId === null
                ? currentWishlists
                : currentWishlists.filter(w => w._id === wishlistId);

            for (let wishlist of wishlists) {
                if (wishlist.items.includes(String(productId))) {
                    return true;
                }
            }

            return false;
        };

        const deleteAll = () => {
            return Promise.all(currentWishlists.map(w => API.deleteWishlist(w._id)));
        };

        const removeProductFromAll = (productId) => {
            let promises = [],
                wishlists = getAllWithProduct(productId);

            for (let wishlist of wishlists) {
                promises.push(API.removeItemFromList(wishlist._id, productId));
            }

            return Promise.all(wishlists);
        };

        const getUniqueProducts = () => {
            return currentWishlists.reduce((list, wishlist) => list.concat(wishlist.items), [])
                .filter((v, i, a) => a.indexOf(v) === i);
        };

        const setLastAddedProductId = (productId) => {
            lastAddedProductId = productId;
        };

        const getLastAddedProductId = () => {
            return lastAddedProductId;
        };

        const fetch = () => {
            return API.getWishlists()
                .then(lists => {
                  lists.map(wishlist => {
                    if (wishlist.type === 'none') {
                      wishlist.type = 'stock';
                    }
                  });
                  currentWishlists = lists;
                })
                .catch(e => {
                    hasError = true
                    console.log('Failed getting wishlists from API')
                })
        };

        return {
            getAll,
            getById,
            getDetails,
            getAllWithProduct,
            hasProduct,
            deleteAll,
            removeProductFromAll,
            getUniqueProducts,
            setLastAddedProductId,
            getLastAddedProductId,
            fetch,
        };
    })();

    const AddToWishlistPopup = (function () {
        let initialized = false,
            loading = false,
            $popup = null,
            currentProductId = null,
            currentVariantId = null,
            currentTitle = null,
            currentProductType = null;

        const init = () => {
            _initTriggers();
            _createElement();
            initialized = true;
        };

        const _initTriggers = () => {
            $body.on('click', '[data-wb-add-to-wishlist]', (e) => {
                e.preventDefault();
                const $trigger = $(e.target).closest('[data-wb-add-to-wishlist]'),
                    productId = $trigger.data('product-id');

                currentProductId = productId;
                currentVariantId = $trigger.data('product-variant-id');
                currentTitle = $trigger.data('product-title');
                currentProductType = $trigger.data('product-type');
                AddToWishlistPopup.show();
            });

            syncAddToWishlistTriggers();
        };

        const _createElement = () => {
            $popup = $(Handlebars.compile(_getTemplate())({
                hasError,
            }));

            $popup.find('.js-backdrop').on('click', hide);
            $popup.find('.js-close').on('click', hide);
            $popup.find('.js-create-list').on('click', () => appendNewWishlist());
            $popup.find('.js-add-to-list').on('click', addCurrentProductToSelectedWishlist);
            $popup.find('.js-remove-from-list').on('click', removeCurrentProductFromSelectedWishlist);
            $popup.on('click', 'input.js-list-title', onInputClick);
            $popup.on('change', 'input[name=current-wishlist]', checkAndToggleAddButtonState);

            $body.append($popup);
        };

        const _createListItem = (title, checked = false, id = 0, type = null) => {
            checked = checked ? 'checked' : '',
                readonly = id ? 'readonly' : '',
                disabled = type != null && type != currentProductType,
                warningTooltip = _createAddToWishlistWarning(disabled, type);

            warningTooltip = warningTooltip ? `title="${warningTooltip}"` : '';

            return `<li class="wb-wishlist-item${disabled ? ' wb-wishlist-item--disabled' : ''}" ${warningTooltip}>
                <div class="wb-wishlist-item__inner">
                    <input type="radio" name="current-wishlist" ${checked} value="${id}" ${disabled ? 'disabled' : ''}> <input type="text" ${readonly} class="js-list-title" value="${title}" ${disabled ? 'disabled' : ''}>
                </div>
            </li>`;
        }

        const _createAddToWishlistWarning = (wishlistDisabled, wishlistType) => {
            let warningText = t('wishlist.addToWishlistWarning');

            if (wishlistDisabled && warningText) {
                warningText = warningText.replace('%1', currentProductType).replace('%2', wishlistType);

                return warningText;
            }
        }

        const _populateListItems = () => {
            // move the wishlists compatible with the current product to top
            let currentWishlists = [...Wishlists.getAll()].sort((a, b) => a.type === currentProductType ? -1 : 0),
                currentItemsHtml = '';

            let itemsHtml = _createListItem(t('wishlist.defaultWishlist'), true);
            if (currentWishlists.length) {
                currentItemsHtml = currentWishlists.map(function (wishlist) {
                    return _createListItem(wishlist.title, false, wishlist._id, wishlist.type);
                }).join('');
            }

            if (currentWishlists.filter(w => w.type === currentProductType).length) {
                itemsHtml = currentItemsHtml;
            } else {
                itemsHtml += currentItemsHtml;
            }

            $popup.find('.js-list').html(itemsHtml);
        };

        const show = () => {
            $body.css({ overflow: 'hidden' });

            _populateListItems();
            selectWishlistWhichContainsProduct(currentProductId);
            selectFirstWishlistIfNoneSelected();
            sync();

            $popup.css({ display: 'flex' });

            setTimeout(() => {
                $popup.find('.js-list input[type=text]').not('[readonly]').last().select();
            }, 100);
        };

        const hide = () => {
            $body.css({ overflow: '' });

            toggleLoading(false);

            $popup.hide();
        };

        const toggleLoading = (val = null) => {
            loading = val !== null ? val : !loading;
            $popup.toggleClass('is-loading', loading);
        };

        const selectWishlistWhichContainsProduct = (itemId) => {
            $popup.find('.js-list > li').each(function (i, item) {
                const $item = $(item),
                    $check = $item.find('input[name="current-wishlist"]');

                if ($check.val() !== '0' && Wishlists.hasProduct(currentProductId, $check.val())) {
                    $check.prop('checked', true);
                }
            });
        }

        const selectFirstWishlistIfNoneSelected = () => {
            const $checks = $popup.find('input[name=current-wishlist]:not([disabled])');
            if (!$checks.filter(':checked').length) {
                $checks.first().prop('checked', true);
            }
        }

        const onInputClick = (e) => {
            const $input = $(e.target),
                $check = $input.closest('.wb-wishlist-item__inner').find('input[name=current-wishlist]');

            $check.get(0).checked = true;
            $check.trigger('change');
        };

        const checkAndToggleAddButtonState = () => {
            $popup.removeClass('is-state-remove');

            $popup.find('input[name=current-wishlist]:checked').each((i, input) => {
                const $input = $(input);
                if (Wishlists.hasProduct(currentProductId, $input.val())) {
                    $popup.addClass('is-state-remove');
                }
            });
        };

        const appendNewWishlist = (title = 'New Wishlist') => {
            const $list = $popup.find('.js-list');

            $list.append(_createListItem(title, true))
                .find('input[type=text]').last().focus().select();

            checkAndToggleAddButtonState();
        };

        const addCurrentProductToSelectedWishlist = () => {
            if (loading) {
                return;
            }

            const $currentRadioButton = $popup.find('input[name=current-wishlist]:checked:not([disabled])');

            if (!$currentRadioButton.length) {
                return;
            }

            toggleLoading(true);

            setTimeout(() => {
                Wishlists.removeProductFromAll(currentProductId)
                    .then(function () {
                        let wishlistId = $currentRadioButton.val();

                        // create new wishlist if it doesn't have an ID
                        if (wishlistId === '0') {
                            let $titleInput = $currentRadioButton.next('.js-list-title');
                            let currentListTitle = $titleInput.val();

                            if (!currentListTitle) {
                                toastr.error('Wishlist title cannot be empty');
                            }

                            API.createWishlist(currentListTitle)
                                .then(function (id) {
                                    $currentRadioButton.val(id);
                                    $titleInput.prop('readonly', true);
                                    addItem(id, currentProductId);
                                });
                        } else {
                            addItem(wishlistId, currentProductId)
                        }
                    });
            }, 100);

            const addItem = (listId, productId) => {
                API.addItemToList(listId, productId)
                    .then(() => {
                        $popup.trigger('added_product', { listId, productId });
                    })
                    .catch((e) => {
                        toggleLoading();
                        let message = (e.responseJSON && e.responseJSON.message)
                            ? e.responseJSON.message
                            : 'Failed adding product to wishlist';

                        toastr.error(message);
                    });
            }
        }

        const removeCurrentProductFromSelectedWishlist = () => {
            if (loading) {
                return;
            }

            toggleLoading(true);

            setTimeout(() => {
                Wishlists.removeProductFromAll(currentProductId)
                    .then(() => {
                        $popup.trigger('removed_product', { productId: currentProductId });
                    });
            }, 100);
        }

        const on = (evt, cb) => {
            $popup.on(evt, cb);
        };

        const sync = () => {
            if (initialized) {
                checkAndToggleAddButtonState();
                syncAddToWishlistTriggers();
            }
        };

        const syncAddToWishlistTriggers = () => {
            $('[data-wb-add-to-wishlist]').each(function (i, trigger) {
                const $trigger = $(trigger),
                    productId = $trigger.data('product-id');

                $trigger.toggleClass('just-added-to-wishlist', Wishlists.hasProduct(productId) && productId === Wishlists.getLastAddedProductId());
                $trigger.toggleClass('is-added-to-wishlist', Wishlists.hasProduct(productId));
            });
        }

        const _getTemplate = () => {
            return `<div class="wb-wishlist-popup wb-wishlist-popup--add">
            <div class="wb-wishlist-popup__backdrop js-backdrop"></div>
            <div class="wb-wishlist-popup__fg">
                <div class="wb-wishlist-popup__loading"></div>
                <div class="wb-wishlist-popup__inner">
                    <button type="button" class="wb-wishlist-popup__close js-close" aria-label="{{t 'wishlist.close'}}"><svg
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path
                                d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6 27.3 411.3c-6.253 6.253-16.37 6.253-22.63 0-6.253-6.253-6.253-16.37 0-22.63L137.4 256 4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63 6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0 6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7c6.3 6.2 6.3 16.4 0 22.6z" />
                        </svg></button>
        
                    {{#unless hasError}}
                    <div class="wb-wishlist-popup__main">
                        <div class="wb-wishlist-popup__available-wishlists-title">{{t 'wishlist.addToList'}}</div>
                        <ul class="wb-wishlist-popup__available-wishlists js-list"></ul>
                    </div>
        
                    <div class="wb-wishlist-popup__foot">
                        <div class="wb-wishlist-popup__buttonbar">
                            <button type="button" class="btn btn--secondary js-create-list">{{t 'wishlist.createList'}}</button>
                            <button type="button" class="btn btn--end js-add-to-list">{{t 'wishlist.addToList'}}</button>
                            <button type="button"
                                class="btn btn--end btn--danger js-remove-from-list">{{t 'wishlist.removeFromList'}}</button>
                        </div>
                    </div>
                    {{else}}
                    <div class="wb-wishlist-popup__main">
                        <div class="wb-wishlist-popup__global-error">Wishlist feature is currently unavailable!</div>
                    </div>
                    {{/unless}}
                </div>
            </div>
        </div>`;
        };

        return {
            loading,
            init,
            show,
            hide,
            toggleLoading,
            selectWishlistWhichContainsProduct,
            checkAndToggleAddButtonState,
            appendNewWishlist,
            addCurrentProductToSelectedWishlist,
            removeCurrentProductFromSelectedWishlist,
            on,
            sync,
        };
    })();

    const MyWishlistsPopup = (function () {
        let loading = false,
            $triggers = null,
            $popup = null,
            $popupHeadSide = null,
            $popupMain = null,
            $popupFootActions = null,
            $confirm = null,
            wishlistsHtml = '',
            currentWishlists = [],
            currentWishlist = null;

        const init = () => {
            _initTriggers();
            _createElement();
            syncWishlists();
            _initActionEvents();
        };

        const _initTriggers = () => {
            $triggers = $('[data-wb-view-my-wishlist]');

            $triggers.on('click', e => {
                e.preventDefault();
                show();
            });

            syncCount();
        };


        const _createElement = () => {
            const template = Handlebars.compile(_getTemplate());
            $popup = $(template({
                footNote: t('wishlist.popupFootNote'),
                hasError,
            }));

            $body.append($popup);

            $popup.find('.js-backdrop').on('click', hide);
            $popup.find('.js-close').on('click', hide);
            $popupHeadSide = $popup.find('.js-head-side');
            $popupMain = $popup.find('.js-main');
            $popupFootActions = $popup.find('.js-foot-actions');
            $confirm = $popup.find('.js-confirm');
            $confirm.find('.js-btn-no').on('click', _hideConfirm);
        };

        const _createWishlistsFootActions = () => {
            let disabled = currentWishlists.length ? '' : 'disabled';
            return `<button type="button" class="wb-wishlist-popup__foot-action wb-wishlist-popup__simple-btn" ${disabled} data-delete-all-wishlists>${t('wishlist.deleteAll')}</button>`
        };

        const _createSingleWishlistFootActions = (listId) => {
            let disabled = currentWishlist.items.length ? '' : 'disabled';
            return `
            <button type="button" class="wb-wishlist-popup__foot-action wb-wishlist-popup__simple-btn" ${disabled} data-clear-single-wishlist="${listId}">${t('wishlist.clearList')}</button>
            <button type="button" class="wb-wishlist-popup__foot-action wb-wishlist-popup__simple-btn" data-delete-single-wishlist="${listId}">${t('wishlist.deleteList')}</button>
            <a href="${theme.routes.cart}" class="wb-wishlist-popup__foot-action wb-btn wb-btn--v2 wb-btn--primary" data-view-cart>${t('cart.viewCart')}</a>
            `;
        };

        const _createHeadSideElement = (wishlist) => {
            return `
            <div class="wb-wishlist-popup__head-side-w">
                <h4 class="wb-wishlist-popup__head-side-w-title">${wishlist.title}</h4>
                <div class="wb-wishlist-popup__head-side-w-count">
                    <span class="wb-wishlist-popup__count">${wishlist.items.length}</span>
                </div>
            </div>
            `;
        };

        const _createWishlistSingleElement = (wishlist) => {
            wishlist.items = wishlist.items.map(product => {
                if(product) {
                    product.imageUrl = product.featuredImage ? product.featuredImage.url : `data:image/jpeg;base64,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`;
                    product.imageAlt = product.featuredImage ? product.featuredImage.alt : '';
                }
                return product;
            });

            return Handlebars.compile(_getSingleTemplate())({
                wishlist,
                allProductsUrl: theme.routes.allProducts,
            });
        };

        const _initActionEvents = () => {
            $popup.on('click', '[data-view-wishlist]', (e) => _viewWishlist($(e.target).data('view-wishlist')));
            $popup.on('click', '[data-clear-wishlist]', (e) => _clearWishlist($(e.target).data('clear-wishlist')));
            $popup.on('click', '[data-delete-wishlist]', (e) => _deleteWishlist($(e.target).data('delete-wishlist')));
            $popup.on('click', '[data-delete-all-wishlists]', () => _deleteAllWishlists());
            $popup.on('click', '[data-back-to-all]', () => _showAllWishlists());
            $popup.on('click', '[data-clear-single-wishlist]', (e) => _clearWishlist($(e.target).data('clear-single-wishlist')));
            $popup.on('click', '[data-delete-single-wishlist]', (e) => _deleteWishlist($(e.target).data('delete-single-wishlist')));
            $popup.on('click', '[data-delete-product]', (e) => _deleteProduct($(e.target).data('delete-product')));
        };

        const show = () => {
            _showAllWishlists();

            $body.css({ overflow: 'hidden' });

            $popup.css({ display: 'flex' });
        };

        const hide = () => {
            $body.css({ overflow: '' });

            $popup.hide();
        };

        const toggleLoading = (val = null) => {
            loading = val !== null ? val : !loading;
            $popup.toggleClass('is-loading', loading);
        };

        const on = (evt, cb) => {
            $popup.on(evt, cb);
        };

        const _showConfirm = (title, cb) => {
            const $yesButton = $confirm.find('.js-btn-yes');

            $confirm.find('.js-confirm-title').text(title);
            $yesButton.on('click', () => {
                $yesButton.prop('disabled', true).addClass('btn--loading');
                $confirm.find('.js-btn-no').prop('disabled', true);

                setTimeout(cb, 100);
            });

            $popup.addClass('is-confirm-active');
        }

        const _hideConfirm = () => {
            $confirm.find('.js-btn-no').prop('disabled', '');
            $confirm.find('.js-btn-yes')
                .off('click')
                .removeClass('btn--loading')
                .prop('disabled', '');

            $popup.removeClass('is-confirm-active');
        };

        const _showAllWishlists = () => {
            currentWishlist = null;
            $popupHeadSide.html('');
            $popupMain.html(wishlistsHtml);
            $popupFootActions.html(_createWishlistsFootActions());
        };

        const _viewWishlist = (id) => {
            toggleLoading();

            setTimeout(() => {
                Wishlists.getDetails(id)
                    .then(wishlist => {
                        currentWishlist = wishlist;
                        $popupHeadSide.html(_createHeadSideElement(wishlist));
                        $popupMain.html(_createWishlistSingleElement(wishlist));
                        $popupFootActions.html(_createSingleWishlistFootActions(id));
                        toggleLoading();
                        setupMultivariants();
                        syncViewCart();
                    });
            }, 100);
        };

        const _clearWishlist = (id) => {
            _showConfirm(
                t('wishlist.clearWishlistPrompt'),
                () => {
                    API.clearWishlist(id)
                        .then(() => {
                            _hideConfirm();
                            currentWishlist ? currentWishlist.items = [] : null;
                            $popup.trigger('cleared_wishlist', { id });
                            toastr.success(t('wishlist.wishlistCleared'));
                        });
                },
            );
        };

        const _deleteWishlist = (id) => {
            _showConfirm(
                t('wishlist.deleteWishlistPrompt'),
                () => {
                    API.deleteWishlist(id)
                        .then(() => {
                            _hideConfirm();
                            currentWishlist = null;
                            $popup.trigger('deleted_wishlist', { id });
                            toastr.success(t('wishlist.wishlistDeleted'));
                        });
                },
            );
        };

        const _deleteAllWishlists = () => {
            _showConfirm(
                t('wishlist.deleteAllWishlistsPrompt'),
                () => {
                    Wishlists.deleteAll()
                        .then(() => {
                            _hideConfirm();
                            $popup.trigger('deleted_all_wishlists');
                            toastr.success(t('wishlist.allWishlistsDeleted'));
                        });
                },
            );
        };

        const _deleteProduct = (productId) => {
            toggleLoading();

            setTimeout(() => {
                API.removeItemFromList(currentWishlist.id, productId)
                    .then(() => {
                        toggleLoading();
                        currentWishlist.items = currentWishlist.items.filter(p => p.id != productId);
                        $popup.trigger('deleted_product', { listId: currentWishlist.id, productId });
                    });
            }, 100);
        };

        const setupMultivariants = () => {
            const managerInstance = new theme.MultivariantsManager($popup);
            managerInstance.setup();
        };

        const sync = () => {
            syncCount();
            syncWishlists();
        };

        const syncCount = () => {
            $triggers.find('.js-count').text(Wishlists.getUniqueProducts().length);
        };

        const syncWishlists = () => {
            wishlistsHtml = Handlebars.compile(_getGroupsTemplate())({
                wishlists: Wishlists.getAll(),
                allProductsUrl: theme.routes.allProducts,
            });

            currentWishlist ? syncCurrentWishlist() : _showAllWishlists();
        };

        const syncCurrentWishlist = () => {
            $popupHeadSide.html(_createHeadSideElement(currentWishlist));
            $popupMain.html(_createWishlistSingleElement(currentWishlist));
            $popupFootActions.html(_createSingleWishlistFootActions(currentWishlist.id));
            setupMultivariants();
        };

        const syncViewCart = () => {
            theme.CartV2.syncViewCartButtons();
        };

        const _getTemplate = () => {
            return `<div id="wbMyWishlistsPopup" class="wb-wishlist-popup wb-wishlist-popup--v2 wb-wishlist-popup--mywishlist">
    <div class="wb-wishlist-popup__backdrop js-backdrop"></div>
    <div class="wb-wishlist-popup__fg">
        <div class="wb-wishlist-popup__confirm js-confirm">
            <div class="wb-wishlist-popup__confirm-fg">
                <div class="wb-wishlist-popup__confirm-title js-confirm-title"></div>

                <div class="wb-wishlist-popup__confirm-actions">
                    <button type="button" class="btn btn--secondary js-btn-no">{{t 'wishlist.no'}}</button>
                    <button type="button" class="btn js-btn-yes">{{t 'wishlist.yes'}}</button>
                </div>
            </div>
        </div>
        <div class="wb-wishlist-popup__loading"></div>

        <div class="wb-wishlist-popup__inner">
            <button type="button" class="wb-wishlist-popup__close js-close" aria-label="{{t 'wishlist.close'}}"><svg
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path
                        d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6 27.3 411.3c-6.253 6.253-16.37 6.253-22.63 0-6.253-6.253-6.253-16.37 0-22.63L137.4 256 4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63 6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0 6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7c6.3 6.2 6.3 16.4 0 22.6z" />
                </svg></button>

            {{#unless hasError}}
            <div class="wb-wishlist-popup__head">
                <div class="wb-wishlist-popup__head-main">
                    <h3 class="wb-wishlist-popup__title">{{t 'wishlist.myWishlists'}}</h3>
                    <div class="wb-wishlist-popup__subtitle">{{t 'wishlist.myWishlistsSubtitle'}}</div>
                </div>

                <div class="wb-wishlist-popup__head-side js-head-side"></div>
            </div>

            <div class="wb-wishlist-popup__main js-main"></div>

            <div class="wb-wishlist-popup__foot">
                {{#if footNote}}
                <div class="wb-wishlist-popup__foot-note">{{footNote}}</div>
                {{/if}}

                <div class="wb-wishlist-popup__foot-main">
                    <div class="wb-wishlist-popup__foot-actions js-foot-actions"></div>
                </div>
            </div>
            {{else}}
            <div class="wb-wishlist-popup__main">
                <div class="wb-wishlist-popup__global-error">Wishlist feature is currently unavailable!</div>
            </div>
            {{/unless}}
        </div>
    </div>
</div>ّ`;
        };

        const _getGroupsTemplate = () => {
            return `{{#if wishlists.length}}
            <div class="wb-wishlist-popup__groups js-list">
                {{#each wishlists}}
                <div class="wb-wishlist-popup__group">
                    <div class="wb-wishlist-popup__group-count">
                        <span class="wb-wishlist-popup__count">{{items.length}}</span>
                    </div>
            
                    <div class="wb-wishlist-popup__group-main">
                        <h4 class="wb-wishlist-popup__group-title">
                            <button class="wb-wishlist-popup__group-title-btn" data-view-wishlist="{{_id}}">{{title}}</button>
                        </h4>
                    </div>
            
                    <div class="wb-wishlist-popup__group-side">
                        <div class="wb-wishlist-popup__group-actions">
                            <button type="button" class="wb-wishlist-popup__group-action" data-view-wishlist="{{_id}}">{{t
                                'wishlist.view'}}</button>
                            <button type="button" class="wb-wishlist-popup__group-action" data-clear-wishlist="{{_id}}">{{t
                                'wishlist.clear'}}</button>
                            <button type="button" class="wb-wishlist-popup__group-action" data-delete-wishlist="{{_id}}">{{t
                                'wishlist.delete'}}</button>
                        </div>
                    </div>
                </div>
                {{/each}}
            </div>
            {{else}}
            <div class="wb-wishlist-popup__empty">
                <div class="wb-wishlist-popup__empty-message">{{t 'wishlist.youHaveNoWishlists'}}</div>
                <div class="wb-wishlist-popup__empty-btn-wrap">
                    <a href="{{allProductsUrl}}" class="btn">{{t 'wishlist.browseShop'}}</a>
                </div>
            </div>
            {{/if}}`;
        };

        const _getSingleTemplate = () => {
            return `<div class="wb-wishlist-popup__back">
            <button type="button" class="wb-wishlist-popup__back-btn" data-back-to-all>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                        d="M447.1 256c0 8.8-6.3 16-15.1 16H68.17l135.7 149.3c5.938 6.531 5.453 16.66-1.078 22.59C199.7 446.6 195.8 448 192 448c-4.344 0-8.688-1.75-11.84-5.25l-160-176c-5.547-6.094-5.547-15.41 0-21.5l160-176c5.969-6.562 16.09-7 22.61-1.094 6.531 5.938 7.016 16.06 1.078 22.59L68.17 240H432c8.8 0 15.1 7.2 15.1 16z" />
                </svg>
                {{t 'wishlist.back'}}
            </button>
        </div>
        
        {{#if wishlist.items.length}}
        <div class="wb-wishlist-popup__products-wrap">
            <div class="wb-wishlist-popup__products">
                {{#each wishlist.items as | product |}}
                {{#if product}}
                <div class="wb-wishlist-popup__product">
                    <div class="wb-wishlist-popup__product-main">
                        <div class="wb-wishlist-popup__product-img-wrp">
                            <a href="{{product.url}}">
                                <img src="{{product.imageUrl}}" alt="{{product.imageAlt}}">
                                <div class="wb-wishlist-popup__product-img-side">{{product.title}}</div>
                            </a>
                        </div>
        
                        <div class="wb-wishlist-popup__product-content">
                            <h5 class="wb-wishlist-popup__product-title">
                                <a href="{{product.url}}">{{product.title}}</a>
                            </h5>
        
                            <div class="wb-wishlist-popup__product-multivariant">
                                <div class="wb-mv" data-product-id="{{product.id}}">
                                    <div class="wb-mv__sk">
                                        <div class="wb-sk wb-sk--multvariant-head"></div>
                                        <div class="wb-sk--multivariant-items">
                                            {{#each [...Array(6)]}}
                                            <span class="wb-sk wb-sk--multivariant-item"></span>
                                            {{/each}}
                                        </div>
        
                                        <div class="wb-sk wb-sk--multivariant-button"></div>
                                        <div class="wb-sk wb-sk--multivariant-wishllist"></div>
                                    </div>
        
                                    <div class="wb-mv__main"></div>
                                </div>
                            </div>
        
                            <div class="wb-wishlist-popup__product-actions">
                                <a href="{{product.url}}" class="wb-wishlist-popup__product-action">{{t 'wishlist.view'}}</a>
                                <button type="button" class="wb-wishlist-popup__product-action js-product-remove"
                                    data-delete-product="{{product.id}}">{{t 'wishlist.delete'}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                {{else}}
                <div class="wb-wishlist-popup__product wb-wishlist-popup__product--invalid">
                    {{t 'wishlist.productIsInvalid'}}
                </div>
                {{/if}}
                {{/each}}
            </div>
        </div>
        {{else}}
        <div class="wb-wishlist-popup__empty">
            <div class="wb-wishlist-popup__empty-message">{{t 'wishlist.yourWishlistIsEmpty'}}</div>
            <div class="wb-wishlist-popup__empty-btn-wrap">
                <a href="{{allProductsUrl}}" class="btn">{{t 'wishlist.browseShop'}}</a>
            </div>
        </div>
        {{/if}}`;
        };

        return {
            init,
            show,
            hide,
            toggleLoading,
            on,
            sync,
            syncCount,
            syncWishlists,
        };
    })();

    function init() {
      setTimeout(() => {
        Wishlists.fetch()
          .then(() => {
            AddToWishlistPopup.init();
            AddToWishlistPopup.on('added_product', onAddedProductToList);
            AddToWishlistPopup.on('removed_product', onRemovedProductFromList);
            
            MyWishlistsPopup.init();
            MyWishlistsPopup.on('cleared_wishlist', syncAll);
            MyWishlistsPopup.on('deleted_wishlist', syncAll);
            MyWishlistsPopup.on('deleted_all_wishlists', syncAll);
            MyWishlistsPopup.on('deleted_product', syncAll);
          });
        
        // gets called every time we re-render products after filtering
        $(document).on('wb_products_loaded', AddToWishlistPopup.sync);
        
        // gets called when recommendations below single product are loaded
        $(document).on('product_recommendations_loaded', AddToWishlistPopup.sync);
      }, 100);
    }

    function onAddedProductToList(e, { productId }) {
        AddToWishlistPopup.hide();
        Wishlists.setLastAddedProductId(productId);
        syncAll();
    }

    function onRemovedProductFromList() {
        AddToWishlistPopup.hide();
        syncAll();
    }

    function syncAll() {
        Wishlists.fetch()
            .then(() => {
                AddToWishlistPopup.sync();
                MyWishlistsPopup.sync();
            });
    }

    init();
});